(function (angular) {
    'use strict';

    angular
        .module('SMART2')
        .constant('APPCONSTANTS', allApplicationConstants());

    function allApplicationConstants() {
        var userActivityStatus = {
            "CREATE_ORDER": "10700003",
            "VIEW_ORDER": "10700005",
            "RECEIVE_AND_ACKNOWLEDGE_ORDER": "10700041",
            "SUBMIT_ORDER_TO_PARTNER": "10700010",
            "CHANGE_CANCEL_ORDER": "10700004",
            "APPROVE_REJECT_ORDER": "10700011",
            "MODIFY_ORDER": "10700018", 
            "ALLOW_BUYERS_TO_EDIT_CATALOG_PRICE_AND_QUANTITY_RESTRICTIONS": "10700065",
            "ALLOW_BUYERS_TO_EDIT_CONTRACTED_PRICE": "10700068",
            "FLIP_REQUISITIONS_TO_ORDER": "10700079",
            "CREATE_SOURCING_EVENT_FROM_REQUISITION": "10700055",
            "SEND_FOR_BIDDING_RFX": "10700054",
            "ACTIVITY_FOR_ASSIGN": "10700090",
            "ACTIVITY_FOR_MANAGE_APPROVALS": "21600004",
            "ACTIVITY_FOR_ISDESTRECEIVER": "10700080",
            "ACTIVITY_FOR_ISRECEIPT": "10700013",
            "CREATE_INVOICE": "10700042",
            "BUYER_ACKNOWLEDGE": "21600005",
            "ALLOW_RESEND_ORDER_TO_SUPPLIER": "21600006",
            "CREATE_INVOICE_BY_FLIPPING_ORDER": "10700048",
            "ALLOW_OVERRIDE_EXCEPTION": "10700077",
            "ALLOW_MANAGE_ADHOC_APPROVERS": "10700060",
            "ALLOW_NONCATALOG_REQUISITION": "21600008",
            "ALLOW_EDITING_OF_ITEM_DETAILS_ON_THE_INVOICE": "10700069",
            "CREATE_REQUISITION": "10700023",
            "AccessSmart20": "21600001",
            "Allow_Requestors_To_Edit_Catalogprice_And_Quantityrestrictions": "10700064",
            "ENABLE_CREATEONBEHALFOF_REQUISITON": "10100043",
            "Edit_Accounting": "10700059",
            "VIEW_Contract": "10400001",
            "CREATE_Contract": "10400003",
            "SUBMIT_INVOICE_FOR_PAYMENT": "10700039",
            "ENABLE_CHANGE_REQUISITION": "11400004",
            "FUNCTIONAL_ADMIN": "11400003",
            "CREATE_REQUISITION_ON_BEHALF_OF" : "10100043",
            "DIRECT_REQUISITION" : "10100044",
            "ALLOW_USERS_TO_EDIT_TOLERANCE_DETAILS": "21600014",
            "ALLOW_TO_SKIP_APPROVAL_STEPS": "10700096",
            "ALLOW_TO_ADD_ADHOC_APPROVER": "10700097",
            "ALLOW_TO_DELETE_APPROVER": "10700098",
            "ALLOW_TO_MANAGE_APPROVAL": "10700057",
            "SUBMIT_REQUISITION_VIA_CART_CHECKOUT" : "21600010",
            "VIEW_Blanket": "10400017",
            "CREATE_Blanket": "10400018",
            "ALLOW_NON_PO_INVOICE_CREATION":"10700082",
            "SELECT_STANDARD_TERMS_AND_CONDITIONS_ON_P2P_DOCUMENTS":"21600045",
            "VENDOR_BUYER_USER": "10700203",
            "REVOKE_CANCEL_ORDER":"21600046",
            "SUPPLIER_REJECTED":"21600047",
            "MARK_AS_ORDERD": "115000038",
            "VIEW_REQUISITION": "115000041",
            "Submit_Requisition": "10700002",
            "Submit_requisition_for_approval": "10700024",
            "ASSIGN_BUYER": "10700304",
            "Replace_line_items_in_PO_from_Catalog": "115000052",
            "ALLOW_ADHOC_REVIEW": "10700401",
            "ALLOW_TO_ADD_ADHOCAPPROVERS_SC": "10700102",
            "APPROVE_REJECT_SC": "10700100",
            "IS_SC_ADMIN": "10700103",
            "APPROVE_REJECT_REQUISITION": "10700001",
            "APPROVE_REJECT_IR": "10700056"
        }
        var ModifyOrder = false;
        var reqToOrder = false;
        var IsApprover = false;
        var isBlanket = false;
        var common = {
            "blanketorder":"blanket order"
        }
        var source = {
            "none": 0,
            "manual": 1,
            "hosted": 2,
            "punchout": 3,
            "template": 4,
            "internal": 5,
            "purchaseRequest": 6
        };
        var requisitionSource = {
            "none": 0,
            "manualRequisition": 1,
            "catalogRequisition": 2,
            "changeRequisition": 3,
            "contractRequisition": 4,
        };

        var MatchtypeEnable = 0;
        var OnEvent = {
            "None": 0,
            "OnSubmit": 1,
            "OnSendToSupplier": 2,
            "SaveAsDraft": 3,
            "OnSubmitFromManageApproval": 4,
            "OnApprove": 5,
            "OnDemandTaxCalculation": 6
        };
        var matchTypeConstants = [
            { "id": 1,"name":"2 way match", "key":"P2P_CMN_TwoWayMatch"},
            { "id": 2,"name":"3 way match", "key":"P2P_CMN_ThreeWayMatch"}
        ];

        var MatchType = {
            1: "P2P_Req_Twoway",
            2: "P2P_Req_Threeway"
        }

        var dispatchMode = [
            { "id": 1, "name": "Portal" },
            { "id": 2, "name": "cXML/EDI" },
            { "id": 3, "name": "Direct Email" },
            { "id": 4, "name": "Call and Submit" },
            { "id": 5, "name": "Fax" }
        ];
        var isNewGrid = false;

        var contractList = [];
        var contractNumberValidationCheckOnSubmit = false;
        var contractNumberType = 3;
        var lobEntityDetailCode = 0;
        var docStateConstants_supplier =
            {
                1: "Invited",
                2: "Registered",
                3: "Disqualified",
                4: "Identified",
                5: "Waitlisted",
                6: "Approved",
                7: "Rejected",
                10: "Non-Compliant",
                11: "CLM Partner"
            };
        var docStateConstants = {
            "Draft": 1,
            "DraftWithdrawn": 2,
            "DraftCoAuthoring": 3,
            "DraftOnHold": 4,
            "PendingContractCreation": 5,
            "DraftAmendment": 6,
            "ContractCreationInProgress": 7,
            "ApprovalPending": 21,
            "Approved": 22,
            "Rejected": 23,
            "Withdrawn": 24,
            "PartnerAcknowledged": 25,
            "AcknowledgementPending": 26,
            "PartiallyAccepted": 27,
            "Accepted": 28,
            "ExecutionPending": 29,
            "TeamReviewPending": 30,
            "SupplierReviewPending": 31,
            "TeamReviewed": 32,
            "TeamRejected": 33,
            "SupplierReviewed": 34,
            "SendForSignature": 35,
            "SignedBySignatory": 36,
            "RejectedBySignatory": 37,
            "SendForSupplierSignature": 38,
            "SupplierSigned": 39,
            "SupplierSignatoryRejected": 40,
            "SubmittedToPartner": 41,
            "SubmittedToBuyer": 42,
            "SentForAcceptance": 43,
            "Published": 44,
            "NotInvited": 45,
            "SupplierInvited": 46,
            "SupplierAccepted": 47,
            "SupplierRejected": 48,
            "ResponseActive": 49,
            "PartnerParticipating": 50,
            "ResponsePending": 51,
            "SentByBuyer": 52,
            "SentToRequester": 53,
            "SentToReceiver": 54,
            "SentBack": 55,
            "SentForBidding": 56,
            "Uploaded": 57,
            "PartnerRevoked": 58,
            "ApprovalRejected": 59,
            "PartialOrderCreated": 61,
            "Ordered": 62,
            "PartialReceipt": 63,
            "FullReceipt": 64,
            "ReturnReceipt": 65,
            "ExcessReceipt": 66,
            "Exception": 67,
            "Matched": 68,
            "NonProcurable": 69,
            "InvoicedStatus": 70,
            "Live": 71,
            "NotYetOpen": 72,
            "Paused": 73,
            "LivePrebid": 74,
            "NotYetOpenForInitialBid": 75,
            "LiveForInitialBid": 76,
            "MatchedWithTolerance": 77,
            "InProgress": 78,
            "Verification": 81,
            "Completed": 82,
            "Execute": 83,
            "ReadyForPayment": 101,
            "SentForPayment": 102,
            "PaymentFailure": 103,
            "InvoicePaid": 104,
            "InvoicePaidWithRemittance": 105,
            "ScoringInProgress": 106,
            "Awarded": 107,
            "Awarding": 108,
            "BiddingCompleted": 109,
            "Cancel": 120,
            "Cancelled": 121,
            "Deleted": 122,
            "Unpublished": 123,
            "Closed": 124,
            "Expired": 125,
            "Terminate": 126,
            "Amended": 127,
            "SendingInProgress": 141,
            "SendingToPartnerFailed": 142,
            "RequestPending": 143,
            "RequestAccepted": 144,
            "RequestRejected": 145,
            "RequestApproved": 146,
            "RequestRejectedOnApproval": 147,
            "CancellationInProgress": 148,
            "CancellationFailed": 149,
            "OnHold": 150,
            "SentForProcessing": 151,
            "SentToERP": 152,
            "InvoicePaymentCancelled": 153,
            "Active": 154,
            "Inactive": 155,
            "CreditMemoPaidWithRemittance": 156,
            "CreditMemoPaymentCancelled": 157,
            "Incomplete": 158,
            "ClosedForInvoicing": 159,
            "ClosedForReceiving": 160,
            "ApprovalRequired": 161,
            "ApprovalWithdrawn": 162,
            "AutoAccepted": 163,
            "Blocked": 164,
            "ResponseInProgress": 165,
            "ResponseClosed": 166,
            "Error": 167,
            "NotStarted": 168,
            "SendForApprovalFailed": 169,
            "SendForProcessingFailed": 170,
            "InternallyCancelled": 171,
            "BudgetOverridePending": 172,
            "Achieved": 173,
            "YetToAchieve": 174,
            "Finalized": 175,
            "Reprocessing": 176,
            "PendingAPReview": 177,
            "RejectedAPReview": 178,
            "New": 179,
            "GuidelinesAcknowledged": 180,
            "ParticipationConfirmed": 181,
            "InvitationDeclined": 182,
            "ResponseSubmitted": 183,
            "ResponseWithdrawn": 184,
            "EventCancelled": 185,
            "EventClosed": 186,
            "EventWithdrawn": 187,
            "EventAwarded": 188,
            "NotAwarded": 189,
            "PrimeRevenue": 190,
            "LinesAccepted": 191,
            "LinesRejected": 192,
            "DraftAmendmentSupplier": 193,
            "AwardRevoked": 194,
            "SendForLinesCollaboration": 195,
            "SendForTermCollaboration": 196,
            "BuyerReviewPending": 197,
            "SupplierCollaborationPending": 198,
            "ReviewPending": 202,
            "FeedbackInDraft": 203,
            "FeedbackPublished": 204,
            "FeedbackInProgress": 205,
            "FeedbackClosed": 206,
            "SentForResolution": 207,
            "DraftApprovalRequired":212,
            "DraftApprovalPending":213,
            "DraftApproved":214,
            "DraftRejected":215,
            "DraftApprovalWithdrawn":216,
            "EventWithdrawnApprovalRequired":217,
            "EventWithdrawnApprovalPending":218,
            "EventWithdrawnApproved":219,
            "EventWithdrawnRejected":220,
            "EventWithdrawnApprovalWithdrawn":221,
            "AwardingApprovalRequired":222,
            "AwardingApprovalPending":223,
            "AwardingApproved":224,
            "AwardingRejected":225,
            "AwardingApprovalWithdrawn":226,
            "AwardedApproved":227,
            "AwardedApprovalWithdrawn": 228,
            "AwardedRejected":231,
            "AwardedApprovalPending": 232,
            "LineReviewPending": 229,
            "LinesReviewed": 230,
            "BidResponseOpened": 233,
            "SupplierRespondedPendingReview": 234,
            "SupplierRespondedReviewerRejected": 235,
            "ReviewerReviewedAndClosed": 236,
            "TechnicalResponseOpened":247,
            "TechnicalEvaluationInProgress":248,
            "SupplierShortlisting":249,
            "CommercialResponseOpened":250,
            "CommercialEvaluationInProgress":251,
            "CommercialEvaluationClosed":252,
            "PartiallySourced": 254,
        "Failed": 255,
        "Queued": 256,
            "InvoiceFullyPaidWithRemittance": 264,
            "InvoicePartiallyPaidWithRemittance":265,
        "COMMON_SentToSupplier":244,
            "ClosedWithAction" : 276 ,
            "PendingGovernanceTeamReview": 277,
            "SetupFinalized": 278,
            "SegmentationFinalized": 279,
            "BidRevisionInProgress": 283,
        "DraftValidationRequired":271,
            "DraftValidationPending":272,
            "DraftValidated":273,
            "DraftValidationDeclined":274,
            "DraftValidationWithdrawn":275,
			"INV_Status_Returned": 999
        };
        var enumDocStateConstants = {
            1: "Draft", 2: "DraftWithdrawn", 3: "DraftCoAuthoring", 4: "DraftOnHold", 5: "PendingContractCreation", 6: "DraftAmendment", 7: "ContractCreationInProgress", 21: "ApprovalPending", 22: "Approved", 23: "Rejected", 24: "Withdrawn", 25: "PartnerAcknowledged", 26: "AcknowledgementPending", 27: "PartiallyAccepted", 28: "Accepted", 29: "ExecutionPending", 30: "TeamReviewPending", 31: "SupplierReviewPending", 32: "TeamReviewed", 33: "TeamRejected", 34: "SupplierReviewed", 35: "SendForSignature", 36: "SignedBySignatory", 37: "RejectedBySignatory", 38: "SendForSupplierSignature", 39: "SupplierSigned", 40: "SupplierSignatoryRejected", 41: "SubmittedToPartner", 42: "SubmittedToBuyer", 43: "SentForAcceptance", 44: "Published", 45: "NotInvited", 46: "SupplierInvited", 47: "SupplierAccepted", 48: "SupplierRejected", 49: "ResponseActive", 50: "PartnerParticipating", 51: "ResponsePending", 52: "SentByBuyer", 53: "SentToRequester", 54: "SentToReceiver", 55: "SentBack", 56: "SentForBidding", 57: "Uploaded", 58: "PartnerRevoked", 59: "ApprovalRejected", 61: "PartiallyOrdered", 62: "Ordered", 63: "PartialReceipt", 64: "FullReceipt", 65: "ReturnReceipt", 66: "ExcessReceipt", 67: "Exception", 68: "Matched", 69: "NonProcurable", 70: "InvoicedStatus", 71: "Live", 72: "NotYetOpen", 73: "Paused", 74: "LivePrebid", 75: "NotYetOpenForInitialBid", 76: "LiveForInitialBid", 77: "MatchedWithTolerance", 78: "InProgress", 81: "Verification", 82: "Completed", 83: "Execute", 101: "ReadyForPayment", 102: "SentForPayment", 103: "PaymentFailure", 104: "InvoicePaid", 105: "InvoicePaidWithRemittance", 106: "ScoringInProgress", 107: "Awarded", 108: "Awarding", 109: "BiddingCompleted", 120: "Cancel", 121: "Cancelled", 122: "Deleted", 123: "Unpublished", 124: "Closed", 125: "Expired", 126: "Terminate", 127: "Amended", 141: "SendingInProgress", 142: "SendingToPartnerFailed", 143: "RequestPending", 144: "RequestAccepted", 145: "RequestRejected", 146: "RequestApproved", 147: "RequestRejectedOnApproval", 148: "CancellationInProgress", 149: "CancellationFailed", 150: "OnHold", 151: "SentForProcessing", 152: "SentToERP", 153: "InvoicePaymentCancelled", 154: "Active", 155: "Inactive", 156: "CreditMemoPaidWithRemittance", 157: "CreditMemoPaymentCancelled", 158: "Incomplete", 159: "ClosedForInvoicing", 160: "ClosedForReceiving", 161: "ApprovalRequired", 162: "ApprovalWithdrawn", 163: "AutoAccepted", 164: "Blocked", 165: "ResponseInProgress", 166: "ResponseClosed", 167: "Error", 168: "NotStarted", 169: "SendForApprovalFailed", 170: "SendForProcessingFailed", 171: "InternallyCancelled", 172: "BudgetOverridePending", 173: "Achieved", 174: "YetToAchieve", 175: "Finalized", 176: "Reprocessing", 177: "PendingAPReview", 178: "RejectedAPReview", 179: "New", 180: "GuidelinesAcknowledged", 181: "ParticipationConfirmed", 182: "InvitationDeclined", 183: "ResponseSubmitted", 184: "ResponseWithdrawn", 185: "EventCancelled", 186: "EventClosed", 187: "EventWithdrawn", 188: "EventAwarded", 189: "NotAwarded", 190: "PrimeRevenue", 191: "LinesAccepted", 192: "LinesRejected", 193: "DraftAmendmentSupplier", 194: "AwardRevoked", 195: "SendForLinesCollaboration", 196: "SendForTermCollaboration", 197: "BuyerReviewPending", 198: "SupplierCollaborationPending", 202: "ReviewPending", 203: "FeedbackInDraft", 204: "FeedbackPublished", 205: "FeedbackInProgress", 206: "FeedbackClosed", 207: "SentForResolution", 212: "DraftApprovalRequired", 213: "DraftApprovalPending", 214: "DraftApproved", 215: "DraftRejected", 216: "DraftApprovalWithdrawn", 217: "EventWithdrawnApprovalRequired", 218: "EventWithdrawnApprovalPending", 219: "EventWithdrawnApproved", 220: "EventWithdrawnRejected", 221: "EventWithdrawnApprovalWithdrawn", 222: "AwardingApprovalRequired", 223: "AwardingApprovalPending", 224: "AwardingApproved", 225: "AwardingRejected", 226: "AwardingApprovalWithdrawn", 227: "AwardedApproved", 228: "AwardedApprovalWithdrawn", 231: "AwardedRejected", 232: "AwardedApprovalPending", 233: "BidResponseOpened", 234: "SupplierRespondedPendingReview", 235: "SupplierRespondedReviewerRejected", 236: "ReviewerReviewedAndClosed", 247: "TechnicalResponseOpened", 248: "TechnicalEvaluationInProgress", 249: "SupplierShortlisting", 250: "CommercialResponseOpened", 251: "CommercialEvaluationInProgress", 252: "CommercialEvaluationClosed", 254: "PartiallySourced", 264: "InvoiceFullyPaidWithRemittance", 265: "InvoicePartiallyPaidWithRemittance", 244: "COMMON_SentToSupplier", 276: "ClosedWithAction", 277: "PendingGovernanceTeamReview", 278: "SetupFinalized", 279: "SegmentationFinalized", 283: "BidRevisionInProgress" };

        var InterfaceStatus = {
            1: "QueuedForERPProcessing",
            2: "SendingToERPInProgress",
            3: "SentToERP",
            4: "AcceptedByERP",
            5: "RejectedByERP",
            6: "CancelledByERP",
            7: "CancellationFailed",
            8: "SendingToERPFailed",
            9: "CancellationToERPInProgress",
	    10: "CancellationSentToERP",
            99: "PickedUpForProcessing",
            100: "UpdatedPickedUpForProcessing"
        };
    var InvoicingStatus = {
        0: "NotInvoiced",
        1: "PartiallyInvoiced",
        2: "FullyInvoiced"
        };

        var InvoiceCreationStatus = {
            0: "InvoiceNotCreated",
            1: "InvoicePartiallyCreated",
            2: "InvoiceFullyCreated",
            3: "InvoiceCredited"
        };

        var DocumentExtendedStatus = {
             1 : "InternalCancellationInProgress",
             2 : "InternalCancellationSuccess",
             3 : "InternalCancellationFailed",
             4 : "ReturnInProgress",
             5: "ReturnSuccess",
            6: "ReturnFailed",
            7: "ValidationInProgress",
            8: "InvoiceVerified",
            9: "InvoiceNotVerified",
            10: "AcceptedByMuleSoft",
            11: "RejectedByMuleSoft"
        };

        var InvoiceComplianceStatus = {
            0: "-",
            1: "Signature Pending",
            2: "Signature Done",
            3: "Signature Failed",
            4: "Validation Pending",
            5: "Validation Done",
            6: "Validation Failed"
        };
        var InvoiceArchivalStatus = {
            0: "-",
            1: "Archival Pending",
            2: "Not Archived",
            3: "Archived"
        };
    
     var OrderInvoicingStatus = {
        "FullyInvoiced": 1,
        "PartiallyInvoiced": 2,
        "OverInvoiced": 3,
        "NotInvoiced": 4
    };
        var fvrtNav = {
            "Task": 1,
            "Manage": 2,
            "Create": 3,
            "Search": 4,
            "Analyze": 5
        };
        var olvmObj = [
            { 'errorCode': 1, 'errorMsg': 'Invalid chart field value' },
            { 'errorCode': 2, 'errorMsg': 'Required field value was blank' },
            { 'errorCode': 3, 'errorMsg': 'Value not active' },
            { 'errorCode': 4, 'errorMsg': 'Effective Date not yet active' },
            { 'errorCode': 5, 'errorMsg': 'Invalid date' },
            { 'errorCode': 6, 'errorMsg': 'Request type invalid for data provided' },
            { 'errorCode': 10, 'errorMsg': 'OLVM server component not able to execute validation' },
            { 'errorCode': 11, 'errorMsg': 'Unsupported request' },
        ];
        //Constat name is added as per icon made by UX in story WS-3065
        var reportIconConstants = {
            0: "Spend",
            1: "Sourcing",
            2: "contract",
            3: "suppllier",
            4: "projects",
            5: 'Procurement',
            6: 'CrossSuite',
            7: 'oppFinderPayment',
            8: "Admin"
        };
        var opportunityFinderIcons = {
            1: { "icon": "#icon_Supplier", "name": "supplierRationalization" },
            2: { "icon": "#icon_logFile", "name": "paymentTermRationalization" },
            3: { "icon": "#icon_order", "name": "oppFinder_poNonPo" },
            4: { "icon": "#icon_Pricing", "name": "oppFinder_purchasePriceVariance" },
            5: { "icon": "#icon_contract", "name": "oppFinder_contractNonContract" },
            6: { "icon": "#icon_normalization", "name": "oppFinder_autoPaymentTermNormalization" },
            7: { "icon": "#icon_improvement", "name": "oppFinder_autoPaymentTermImprovement" },
            8: { "icon": "#icon_bestPaymentDateSuppliers", "name": "oppFinder_bestPaymentDateSuppliers" },
            9: { "icon": "#icon_bestPaymentDateCategories", "name": "oppFinder_bestPaymentDateCategories" },
            10: { "icon": "#icon_invoice_consolidation", "name": "oppFinder_invoiceConsolidation"},
            11: { "icon": "#icon_Spend", "name": "Tail Spend" },
            12: { "icon": "#icon_Duplicate_material", "name": "Duplicate Materials" }
        };
        var auctionTypeConstants = {
            'All': 0,
            'Regular': 1,
            'Dutch':  2,
            'Japanese' : 3,
            'Sealed' : 4
        };
        var doctypeConstants = {
            "none": 0,
            "rfp": 1,
            "rfq": 2,
            "rfi": 3,
            "auction": 4,
            "contract": 5,
            "catelog": 6,
            "requisition": 7,
            "po": 8,
            "invoice": 9,
            "receipts": 10,
            "forms": 11,
            "assessment": 12,
            "item": 13,
            "invoicereconcillation": 14,
            "scannedimage": 15,
            "contractrequest": 16,
            "rfxrequest": 17,
            "auctionrequest": 18,
            "partnerprofile": 19,
            "returnnote": 20,
            "project": 21,
            "creditmemo": 22,
            "actionplan": 23,
            "program": 24,
            "approvalformpartner": 25,
            "approvalupdatepartnerprofile": 26,
            "paymentrequest": 27,
            "categoryworkbench": 28,
            "approvalrulebasedstatuschange": 29,
            "blanket": 30,
            "serviceconfirmation": 31,
            "asn": 34,
            "invoiceapuser": 91,
            "invoicesupplier": 92,
            "creditmemoapuser": 93,
            "creditmemosupplier": 94,
            "projectrequest": 33,
            "report": -3,
            "opportunityfinder": -4,
            "procurementprofile": 38,
            "timesheet":39,
            "uploadexcel":-10,
            "ShouldCost":40,
            "BillOfMaterial":41,
            "section": 1018,
            "ItemMaster":43,
            "SourcingList": 42,
            "DemandPlanning": 44,
            "ChargeSheet": 46,
            "ForecastModeling": 48,
            "RequestTemplate": 52,
            "RequestForm" : 53,
            "forecastWorkbench":1030,
            "incidentreport": 58,
            "Segmentation": 59,
            "anomaly": 1060,
            "vision": 1058,
            "FactSheet": 60,
            "SupplierRequest": 65
        };

        var smartNavTileConfig = {
            "-3": {

                "name": "ReportCreate",
                "id": "createReportCreate",
                "icon": "#icon_Report",
                //"href": "/Analytics?oloc=224/index#/report/new",
                "fullname": "ReportCreate",
                'isCustomTemplate': true,
                "docID": "-3"
            },
            "-4": {
                "name": "OpportunityFinderCreate",
                "id": "createOpportunityFinderCreate",
                "icon": "#icon_Report",
                //"href": "/Analytics?oloc=224/index#/report/new",
                "fullname": "OpportunityFinder",
                'isCustomTemplate': true,
                "docID": "-4"
            },
            "0": {
                "name": "None",
                "id": "createNone",
                "icon": "",
                "href": "",
                "docID": "0"
            },
            "1": {
                "name": "rfx",
                "id": "createRfx",
                "icon": "#icon_RFX",
                "href2": "/Sourcing/Rfx?oloc=219&c=[bpc]&isFromWorkSpace=true#/rfx/new",
                "fullname": "rfx",
                "queryStringKey": "rfxQueryString",
                "docID": "1"
            },
            "2": {
                "name": "rfq",
                "id": "createRfq",
                "icon": "#icon_RFX",
                "href2": "/Sourcing/Rfx?oloc=219&c=[bpc]&isFromWorkSpace=true#/rfx/new",
                "fullname": "Request_for_Quotation",
                "queryStringKey": "rfxQueryString",
                "docID": "1"
            },
            "3": {
                "name": "rfi",
                "id": "createRfi",
                "icon": "#icon_RFX",
                "href2": "/Sourcing/Rfx?oloc=219&c=[bpc]&isFromWorkSpace=true#/rfx/new",
                "queryStringKey": "rfxQueryString",
                "docID": "1"
            },
            "4": {
                "name": "auction",
                "id": "createAuction",
                "icon": "#icon_Auction",
                //"href": "/Sourcing/Events/CreateEvent?dd=[dd]&[md]&dt=4&oloc=103",
                "fullname": "auction",
                "queryStringKey": "auctionQueryString",
                "docID": "4"
            },
            "5": {
                "name": "contract",
                "id": "createContract",
                "icon": "#icon_Contract",
                "href2": "Contract/ContractInfo/NewContract?oloc=104&c=[bpc]&dd=[dd]&dt=5#/contract/new",
                "fullname": "contract",
                "queryStringKey": "contractQueryString",
                "docID": "5"
            },
            "6": {
                "name": "catalog",
                "id": "createCatalog",
                "icon": "#icon_Catalog",
                "href": "",
                "fullname": "catalog",
                "queryStringKey": "catalogQueryString",
                "docID": "6"
            },
            "7": {
                "name": "requisition",
                "id": "createRequisition",
                "icon": "#icon_Requisition",
                "href2": "/P2P/Index?dd=[dd]&oloc=227&c=[bpc]#/requisitions/[dd]",
                "fullname": "requisition",
                "queryStringKey": "requisitionQueryString",
                "docID": "7"
            },
            "8": {
                "name": "po",
                "id": "createPo",
                "icon": "#icon_Order",
                "href": "/Order/ManageOrder/Create?dd=[dd]&[md]&oloc=107&c=[bpc]",
                "href2": "/P2P/Order?dd=[dd]&oloc=226&c=[bpc]#/po",
                "fullname": "po",
                "queryStringKey": "orderQueryString",
                "docID": "8"
            },
            "9": {
                "name": "invoice",
                "id": "createInvoice",
                "icon": "#icon_Invoice",
                "href2": "/P2P/Invoice?dd=[dd]&oloc=225&c=[bpc]#/invoice",
                "fullname": "invoice",
                "queryStringKey": "invoiceQueryString",
                "docID": "9"
            },
            "10": {
                "name": "receipt",
                "id": "createReceipt",
                "icon": "#icon_Receipt",
                "href": "/Receipt/ManageReceipt/Create?dd=[dd]&[md]&oloc=107&c=[bpc]",
                "fullname": "receipt",
                "queryStringKey": "receiptQueryString",
                "docID": "10"
            },
            "11": {
                "name": "forms",
                "id": "createForms",
                "icon": "#icon_Form",
                //"href": "/PartnerManagement/Form/createform?dd=[dd]&[md]&oloc=105",
                //"href2": "/supplierManagement/Form?dd=[dd]&oloc=216#/supplier/form",
                "fullname": "form",
                "queryStringKey": "formQueryString",
                "docID": "11"
            },
            "12": {
                "name": "assessment",
                "id": "createAssessment",
                "icon": "#icon_Scorecard",
                //"href": "/PartnerManagement/Assessment/CreateAssessment?dd=[dd]&[md]&oloc=105",
                //"href2": "/supplierManagement/Scorecard?dd=[dd]&oloc=216#/supplier/scorecard",
                "fullname": "assessment",
                "queryStringKey": "assessmentQueryString",
                "docID": "12"
            },
            "13": {
                "name": "item",
                "id": "createItem",
                "icon": "",
                "href": "",
                "docID": "13"
            },
            "14": {
                "name": "invoiceReconciliation",
                "id": "createInvoiceReconciliation",
                "icon": "#icon_InvRecon",
                "href": "/IR/ManageIR/Create?dd=[dd]&[md]&oloc=107&c=[bpc]",
                "fullname": "invoicereconciliation",
                "queryStringKey": "invoiceReconcillationQueryString",
                "docID": "14"
            },
            "15": {
                "name": "scanned_image",
                "id": "createScanned_image",
                "icon": "",
                "href": "",
                "docID": "15"
            },
            "16": {
                "name": "contract_request",
                "id": "createContract_request",
                "icon": "#icon_contractRequest",
               // "href": "/Portal/Request/CreateRequest?dd=[dd]&[md]&rdt=16&oloc=101&c=[bpc]",
                "fullname": "contractrequest",
                "queryStringKey": "contractRequestQueryString",
                "docID": "16"
            },
            "17": {
                "name": "rfxrequest",
                "id": "createRfxRequest",
                "icon": "#icon_rfxRequest",
                "href": "/Portal/Request/CreateRequest?dd=[dd]&[md]&rdt=17&oloc=101&c=[bpc]",
                "fullname": "RFx_Request",
                "queryStringKey": "rfxRequestQueryString",
                "docID": "17"
            },
            "18": {
                "name": "auction_request",
                "id": "createAuction_request",
                "icon": "#icon_auctionRequest",
                "href": "/Portal/Request/CreateRequest?dd=[dd]&[md]&rdt=18&oloc=101&c=[bpc]",
                "fullname": "auction_request",
                "queryStringKey": "auctionRequestQueryString",
                "docID": "18"
            },
            "19": {
                "name": "partner_profile",
                "id": "createPartner_profile",
                "icon": "#icon_Supplier",
                "href": "/PartnerManagement/Partners/AddNewPartner?dd=[dd]&[md]&oloc=105&c=[bpc]",
                "href2": "/SupplierManagement/AddNewSupplier?dd=[dd]&oloc=105&c=[bpc]#/supplier/new",
                "fullname": "partner_profile",
                "queryStringKey": "partnersQueryString",
                "docID": "19"
            },
            "20": {
                "name": "return_note",
                "id": "createReturn_note",
                "icon": "#icon_IncidentReport",
                "href": "/P2P/ReturnNote?dd=[dd]&[md]&oloc=236&c=[bpc]#/ReturnNote",
                "fullname": "returnnote",
                "queryStringKey": "returnNoteQueryString",
                "docID": "20"
            },
            "21": {
                "name": "project",
                "id": "createProject",
                "icon": "#icon_projects",
                //"href": "/PPST/Project/createproject?oloc=113&[md]",
                //"href2": "/PPST/Project/Index?oloc=223#/ppst/create",
                "fullname": "project",
                "queryStringKey": "projectQueryString",
                "docID": "21"
            },
            "22": {
                "name": "Credit Memo",
                "id": "createCredit_Memo",
                "icon": "#icon_CredMemo",
                //"href": "/CreditMemo/ManageCreditMemo/Create?dd=[dd]&[md]&oloc=107&c=[bpc]",
                "fullname": "creditmemo",
                "queryStringKey": "creditMemoQueryString",
                "docID": "22"
            },
            "23": {
                "name": "actionPlan",
                "id": "createActionPlan",
                "icon": "#icon_ActionPlan",
                "href": "/PartnerManagement/ActionPlan/CreateActionPlan?dd=[dd]&[md]&oloc=105&c=[bpc]",
                "fullname": "actionPlan",
                "queryStringKey": "actionPlanQueryString",
                "docID": "23"
            },
            "24": {
                "name": "program",
                "id": "createProgram",
                "icon": "#icon_RfxDraft",
                "href": "/Program/ManageProgram/Create?dd=[dd]&[md]&oloc=107&c=[bpc]",
                "fullname": "program",
                "queryStringKey": "programQueryString",
                "docID": "24"
            },
            "25": {
                "name": "approval_form_partner",
                "id": "createApproval_form_partner",
                "icon": "",
                "href": "",
                "docID": "25"
            },
            "26": {
                "name": "approval_update_partner_profile",
                "id": "createApprovalUpdatePartnerProfile",
                "icon": "",
                "href": "",
                "docID": "26"
            },
            "27": {
                "name": "paymentRequest",
                "id": "createPaymentRequest",
                "icon": "#icon_paymentRequest",
                "href": "/PaymentRequest/ManagePaymentRequest/Create?dd=[dd]&[md]&rdt=27&oloc=107&c=[bpc]",
                "fullname": "paymentrequest",
                "queryStringKey": "paymentRequestQueryString",
                "docID": "27"
            },
            "28": {
                "name": "category_workbench",
                "id": "createCategory_workbench",
                "icon": "#icon_CategoryWor",
                "href": "/cw/document/vista?oloc=116&dd=[dd]&c=[bpc]#/dm/admin/fw/section",
                "fullname": "CategoryWorkbench",
                "docID": "28"
            },
            "29": {
                "name": "Approval Rule Based Status Change",
                "id": "createApprovalrulebasedstatuschange",
                "icon": "",
                "href": "",
                "docID": "29"
            },
            "30": {
                "name": "blanket",
                "id": "createBlanket",
                "icon": "#icon_blanket",
                "href2": "Contract/ContractInfo/NewBlanket?oloc=104&c=[bpc]&dd=[dd]&dt=30#/blanket/new",
                "fullname": "blanket",
                "queryStringKey": "blanketQueryString",
                "docID": "30"
            },
            "31": {
                "name": "service_confirmation",
                "id": "createService_confirmation",
                "icon": "#icon_ServiceConfirmation",
                // "href": "/ServiceConfirmation/ManageServiceConfirmation/Create?dd=[dd]&[md]&oloc=107&c=[bpc]#/serviceConfirmation/setup",
                "fullname": "service_confirmation",
                "queryStringKey": "serviceConfirmationQueryString",
                "docID": "31"
            },
            "33": {
                "name": "projectRequest",
                "id": "createProjectRequest",
                "icon": "#icon_projectsRequest",
                "href": "/ppst/project/index?&oloc=223&c=[bpc]#/projectRequest/create",
                "href2": "/ppst/project/index?&oloc=223&c=[bpc]#/projectRequest/create",
                "fullname": "Project_Request",
                "queryStringKey": "",
                "docID": "33"
            },
            "34": {
                "name": "asn",
                "id": "createAsn",
                "icon": "#icon_asn",
                "href": "",
                "href2": "/P2P/ASN?dd=[dd]&oloc=228&c=[bpc]#/po",
                "fullname": "Advance_Shipping_Notice",
                "queryStringKey": "asnQueryString",
                "docID": "34"
            },
            "38": {
                "name": "ProcurementProfile",
                "id": "createProcurementProfile",
                "icon": "#icon_ProcProfile",
                "href": "/P2P/ProcurementProfile?dd=[dd]&oloc=232&c=[bpc]#/ProcurementProfile",
                "fullname": "ProcurementProfile",
                "queryStringKey": "asnQueryString",
                "docID": "38"
            },
            "39": {
                "name": "Timesheet",
                "id": "createTimesheet",
                "icon": "#icon_timesheet",
                // "href": "/ServiceConfirmation/ManageServiceConfirmation/Create?dd=[dd]&[md]&oloc=107&c=[bpc]#/serviceConfirmation/setup",
                "fullname": "Timesheet",
                "queryStringKey": "serviceConfirmationQueryString",
                "docID": "39"
            },
            "91": {
                "name": "Invoice APUser",
                "id": "createInvoiceAPUser",
                "icon": "",
                "href": "",
                "docID": "91"
            },
            "92": {
                "name": "Invoice Supplier",
                "id": "createInvoiceSupplier",
                "icon": "",
                "href": "",
                "docID": "92"
            },
            "93": {
                "name": "Credit Memo AP User",
                "id": "createCreditMemoAPUser",
                "icon": "",
                "href": "",
                "docID": "93"
            },
            "94": {
                "name": "Credit Memo Supplier",
                "id": "createCreditMemoSupplier",
                "icon": "",
                "href": "",
                "docID": "94"
            },
            "-10": {
                "name": "upload_excel",
                "id": "createupload_excel",
                "icon": "",
                "href": "",
                "docID": "95"
            },
            "40": {
                "name": "Should Cost",
                "id": "createShouldCost",
                "icon": "#icon_shouldCost",
                //"href2": "",
                "fullname": "Should Cost",
                "queryStringKey": "ShouldCostString",
                "docID": "40"
            },
            "48": {
                "name": "Forecast Modeling",
                "id": "createForecastModeling",
                "icon": "#icon_ForecastModeling",
                "href": "?dd=[dd]&oloc=316&c=[bpc]#/cm/ly/wm",
                "fullname": "Forecast Modeling",
                "queryStringKey": "ForecastModelingString",
                "docID": "48"
            },
            "41": {
                "name": "BillOfMaterial",
                "id": "createBillOfMaterial",
                "icon": "#icon_shouldCost",
                //"href2": "",
                "fullname": "BillOfMaterial",
                "queryStringKey": "BillOfMaterialString",
                "docID": "41"
            },
            "43": {
                "name": "Item Master",
                "id": "createItemMaster",
                "icon": "#icon_shouldCost",
                //"href2": "",
                "fullname": "Item Master",
                "queryStringKey": "ItemMasterString",
                "docID": "43"
            },
            "1018": {
                "name": "section",
                "id": "createsection",
                "icon": "",
                "href": "",
                "docID": "1018"
            },
            "42": {
                "name": "SourcingList",
                "id": "createSourcingList",
                "icon": "#icon_sourcinglist",
                "href": "/?dd=[dd]&oloc=261&sl=1&b=1&c=[bpc]",
                "fullname": "SourcingList",
                "queryStringKey": "SourcingListString",
                "docID": "42"
            },
            "44": {
                "name": "Demand Planning",
                "id": "createDemandPlanning",
                "icon": "#icon_demandPlanning",
                //"href2": "",
                "fullname": "Demand Planning",
                "queryStringKey": "DemandPlanningString",
                "docID": "44"
            },
            "46": {
                "name": "ChargeSheet",
                "id": "createChargeSheet",
                "icon": "#icon_chargeSheet",
                "href": "[workspacebaseurl]#/landingmax?pagefor=manage&scope=chargesheet",
                "fullname": "ChargeSheet",
                "queryStringKey": "",
                "docID": "46"
            },
            "52": {
                "name": "Purchase Request Template",
                "id": "createRequestTemplate",
                "icon": "#icon_Requisition",
                "href": "/RequestForm/Index?dd=[dd]&oloc=557&c=[bpc]#/prt/ly/fw",
                "fullname": "Purchase Request Template",
                "queryStringKey": "",
                "docID": "52"
            },
            "53": {
                "name": "Purchase Request Form",
                "id": "createRequestForm",
                "icon": "#icon_Requisition",
                "fullname": "Purchase Request Form",
                "queryStringKey": "",
                "docID": "53"
            },
            "58": {
                "name": "Incident Report",
                "id": "incidentreport",
                "icon": "#icon_SupplierIncident",
                "href": "/?oloc=539&c=[bpc]#/sir/0",
                "fullname": "Incident Report",
                "queryStringKey": "",
                "docID": "58"
            },
            "59": {
                "name": "Segmentation",
                "id": "Segmentation",
                "icon": "#icon_Segmentation",
                "href": "/?oloc=539&c=[bpc]#/segmentation/0",
                "fullname": "Segmentation",
                "queryStringKey": "",
                "docID": "59"
            },
            "60": {
                "name": "Factsheet Template",
                "id": "createFactSheet",
                "icon": "#icon_FactSheet",
                "href": "/FactSheet/Index?oloc=638&dd=[dd]&c=[bpc]",
                "fullname": "Factsheet Template",
                "queryStringKey": "",
                "docID": "60"
            },
            "65": {
                "name": "SupplierRequest",
                "id": "SupplierRequest",
                "icon": "#icon_SupplierRequest",
                "href": "/SupplierManagement/SupplierRequest?dd=[dd]&oloc=105&c=[bpc]#/supplier/supplierRequest",
                "fullname": "SupplierRequest",
                "queryStringKey": "",
                "docID": "65"
            }
        };

        var documentPriority = [7, 8, 10, 27, 9, 14, 22, 24, 0, 1, 2, 3, 4, 5, 6, 11, 12, 13, 15, 16, 17, 18, 19, 20, 21, 23, 25, 26, 28, 29, 30, 31, -3, 38,39,-4,40,41,42,43,44,46,48,52,53,1030,58,59,60,1060,1058,65];

        function setDocumentPriority(newPriorty) {
            documentPriority = newPriorty;

        }

        var globalSearchConstant = {
            "Items": 3
        };

        var doctypeImages = {
            1: "RFX",
            2: "RFX",
            3: "RFX",
            4: "Auction",
            5: "Contract",
            6: "Catalog",
            7: "Requisition",
            8: "Order",
            9: "Invoice", //Invoice image not found
            10: "Receipt", //Receipt image not found
            11: "Form", //Forms image not found
            12: "Scorecard", //Scorecard image  found  -done
            13: "Item", //Item image not found
            14: "InvRecon",
            15: "ScnImg", //ScannedImage image not found
            16: "Contract", //ContractRequest image not found
            17: "RFX",
            18: "Auction", //AuctionRequest image not found
            19: "Supplier", //PartnerProfile image not found
            20: "Receipt", //ReturnNote image not found
            21: "projects", //Project image not found
            22: "CredMemo", //CreditMemo image not found
            23: "ActionPlan", //ActionPlan image not found
            24: "Program", //Program image not found
            25: "AppFormPart", //ApprovalFormPartner image not found
            26: "AppUpPartProf", //ApprovalUpdatePartnerProfile image not found
            27: "PaymentReq",
            28: "CategoryWor", //catwrkbnck was there//CategoryWorkbench image not found
            29: "AppRuleBsdStatChng", //ApprovalRuleBasedStatusChange image not found
            30: "blanket",//Blanket image not found
            31: "ServiceConfirmation",
            34: "ASN",
            33: "projects",//Project Request use project_icon
            38: "ProcProfile",
            39: "Timesheet",
            90: "SvcConf", //ServiceConfirmation image not found
            91: "InvAPUsr", //InvoiceApUser image not found
            92: "InvSup", //InvoiceSupplier image not found
            93: "CrdMemoAPUsr", //CreditMemoAPUser image not found
            94: "CrdMemoSup", //CreditMemoSupplier image not found
            40: "ShouldCost",
            41: "BillOfMaterial",
            43: "ItemMaster",
            42: "SourcingList",
            44: "DemandPlanning",
            46: "ChargeSheet",
            48: "ForecastModeling",
            52: "RequestTemplate",
            53: "RequestForm",
            58: "incidentreport",
            59: "Segmentation",
            60: "FactSheet",
            65: "SupplierRequest"
        };

        var docType = {
            "-4": "opportunityfinder",
            "-3": "report",
            1: "RFX",
            2: "RFQ",
            3: "RFI",
            4: "Auction",
            5: "Contract",
            6: "Catalog",
            7: "Requisition",
            8: "Order",
            9: "Invoice", //Invoice image not found
            10: "Receipt", //Receipt image not found
            11: "Forms", //Forms image not found
            12: "Scorecards", //Assessment image not found
            13: "Item", //Item image not found
            14: "InvoiceReconciliation",
            15: "scannedInvoice", //ScannedImage image not found
            16: "ContractRequest", //ContractRequest image not found
            17: "RFxRequest",
            18: "AuctionRequest", //AuctionRequest image not found
            19: "partners", //PartnerProfile image not found
            20: "ReturnNote", //ReturnNote image not found
            21: "Project", //Project image not found
            22: "CreditMemo", //CreditMemo image not found
            23: "ActionPlan", //ActionPlan image not found
            24: "Program", //Program image not found
            25: "ApprovalFormPartner", //ApprovalFormPartner image not found
            26: "ApprovalUpdatePartnerProfile", //ApprovalUpdatePartnerProfile image not found
            27: "PaymentRequest",
            28: "CategoryWorkbench", //CategoryWorkbench image not found
            29: "ApprovalRuleBasedStatusChange", //ApprovalRuleBasedStatusChange image not found
            30: "Blanket", //Blanket image not found
            31: "ServiceConfirmation", //ServiceConfirmation image not found
            33: "ProjectRequest",
            34: "ASN",
            36: "Smartbuy",
          37: "SRF",
            38: "ProcurementProfile",
            39: "Timesheet",
            91: "InvAPUsr", //InvoiceApUser image not found
            92: "InvSup", //InvoiceSupplier image not found
            93: "CrdMemoAPUsr", //CreditMemoAPUser image not found
            94: "CrdMemoSup", //CreditMemoSupplier image not found
            "-10":"uploadexcel",
            40: "ShouldCost",
            41: "BillOfMaterial",
                43: "ItemMaster",
            1018: "section",
            42: "SourcingList",
            44: "DemandPlanning",
            46: "ChargeSheet",
            48: "ForecastModeling",
            52: "RequestTemplate",
            53: "RequestForm",
            1030: "forecastWorkbench",
            58: "incidentreport",
            59: "Segmentation",
            1060: "anomaly",
            1058: "vision",
            60: "FactSheet",
            65: "SupplierRequest"
        };

        var doctypeColors = {
            1: "sourcing-module",
            2: "sourcing-module",
            3: "sourcing-module",
            4: "sourcing-module",
            5: "sourcing-module",
            6: "p2p-module",
            7: "p2p-module",
            8: "p2p-module",
            9: "p2p-module", //Invoice image not found
            10: "p2p-module", //Receipt image not found
            11: "sourcing-module", //Forms image not found
            12: "sourcing-module", //Assessment image not found
            13: "Item", //Item image not found
            14: "p2p-module",
            15: "ScnImg", //ScannedImage image not found
            //16: "Request", //ContractRequest image not found
            16: "p2p-module", //ContractRequest image not found
            //17: "RfxReq",
            17: "p2p-module",
            //18: "AucReq", //AuctionRequest image not found
            18: "p2p-module", //AuctionRequest image not found
            19: "supplier-module", //PartnerProfile image not found
            20: "p2p-module", //ReturnNote image not found
            21: "project-module", //Project image not found
            22: "p2p-module", //CreditMemo image not found
            23: "sourcing-module", //ActionPlan image not found
            24: "p2p-module", //Program image not found
            25: "AppFormPart", //ApprovalFormPartner image not found
            26: "AppUpPartProf", //ApprovalUpdatePartnerProfile image not found
            //27: "PaymentReq",
            27: "p2p-module",
            28: "project-module", //CategoryWorkbench image not found
            29: "AppRuleBsdStatChng", //ApprovalRuleBasedStatusChange image not found
            30: "p2p-module", //Blanket image not found
            31: "p2p-module", //ServiceConfirmation image not found
            34: "p2p-module",
            90: "p2p-module", //ServiceConfirmation image not found
            91: "InvAPUsr", //InvoiceApUser image not found
            92: "supplier-module", //InvoiceSupplier image not found
            93: "CrdMemoAPUsr", //CreditMemoAPUser image not found
            94: "supplier-module" //CreditMemoSupplier image not found
        };

        var docStateImages = {
            "drafts": "RfxDraft",
            "pendingapprovals": "RfxReqPendi",
            "followup": "RfxReqPendi",
            "pendingacceptance": "Receipt",
            "pendingreceivings": "Receipt",
            "unprocessedrequisitions": "RfxReqPendi",
            "responsecomplete": "RfxDraft",
            "scoringinprogress": "RfxReqPendi",
            "awarding": "Receipt",
            "invited": "RfxReqPendi",
            "actionpending": "RfxReqPendi",
            "responsepending": "RfxDraft",
            "evaluationpending": "RfxReqPendi",
            "requisition": "Requisition",
            "order": "Order",
            "invoicereconciliation": "InvRecon",
            "invoicereconcillation": "InvRecon",
            "creditnote": "CredMemo",
            "creditmemo": "CredMemo",
            "asn": "asn",
            "receipt": "Receipt",
            "returnnote": "Receipt",
            "catalog": "Catalog",
            "supplier": "Supplier",
            "suppliers": "Supplier",
            "rfx": "RFX",
            "contract": "Contract",
            "punchout": "POPartner",
            "program": "Program",
            "paymentrequest": "paymentRequest",
            "partners": "Supplier",
            "partner": "Supplier",
            "scorecards": "Scorecard",
            "scorecard": "Scorecard",
            "forms": "Form",
            "form": "Form",
            "request": "Request",
            "auctions": "Auction",
            "auction": "Auction",
            "invoice": "Invoice",
            "actionplan": "ActionPlan",
            "project": "projects",
            "projects": "projects",
            "blanket": "blanket",
            "blankets": "blanket",
            "serviceconfirmation": "ServiceConfirmation",
            "timesheet": "timesheet",
            "rfxrequest": "rfxRequest",
            "auctionrequest": "auctionRequest",
            "contractrequest": "contractRequest",
            "report": "Report",
            "reports": "Reports",
            "categoryworkbench": 'CategoryWor',
            'po': 'Order',
            'partnerprofile': 'supplierProfile',
            'supplierprofile': 'supplierProfile',
            'scannedinvoice': 'scannedDocument',
            'catelog': 'Catalog',
            'creditmemoapuser': 'CredMemo',
            'creditmemosupplier': 'CredMemo',
            'invoiceapuser': 'Invoice',
            'invoicesupplier': 'invoiceSuppliers',
            'item': 'items',
            'receipts': 'Receipt',
            'assessment': 'Scorecard',
            'projectrequest': 'projectsRequest',
            'spend': 'Spend',
            'sourcing': 'sourcing',
            'suppllier': 'Supplier',
            'procurement': 'P2P',
            'crosssuite': 'crossSuite',
            'oppfinderpayment': 'logFile',
            'admin': 'Report',
            'shouldcost': 'shouldCost',
            'forecastmodeling':'forecastModeling',
            'itemmaster':'itemMaster',
            'sourcinglist': 'sourcinglist',
            'demandplanning':'demandPlanning',
            'procurementprofile' : 'ProcProfile' ,
            'Chargesheet': 'chargeSheet',
            'billofmaterial' : 'shouldCost',
            'forecasting':'forecasting',
            'incidentreport': 'incidentreport',
            'segmentation': 'Segmentation',
            'factsheet' : 'FactSheet',
            'supplierrequest': 'SupplierRequest'
        };

        var docStateColors = {
            "drafts": "koromiko",
            "pendingapprovals": "asparagus",
            "followup": "cornflower-blue",
            "pendingacceptance": "slate-blue",
            "pendingreceivings": "cornflower-blue",
            "unprocessedrequisitions": "slate-blue",
            "responsecomplete": "asparagus",
            "scoringinprogress": "cornflower-blue",
            "awarding": "slate-blue",
            "invited": "cornflower-blue",
            "actionpending": "asparagus",
            "responsepending": "cornflower-blue",
            "evaluationpending": "slate-blue",
            "requisition": "red-orange",
            "order": "summer-sky",
            "invoicereconciliation": "koromiko",
            "invoicereconcillation": "koromiko",
            "creditnote": "asparagus",
            "creditmemo": "cornflower-blue",
            "asn": "summer-sky",
            "receipt": "cornflower-blue",
            "returnnote": "slate-blue",
            "catalog": "red-orange",
            "supplier": "summer-sky",
            "suppliers": "summer-sky",
            "rfx": "koromiko",
            "contract": "asparagus",
            "punchout": "cornflower-blue",
            "program": "red-orange",
            "paymentrequest": "summer-sky",
            "partners": "slate-blue",
            "partner": "summer-sky",
            "scorecards": "summer-sky",
            "forms": "cornflower-blue",
            "request": "red-orange",
            "auctions": "slate-blue",
            "auction": "slate-blue",
            "invoice": "cornflower-blue",
            "actionplan": "koromiko",
            "projects": "red-orange",
            "project": "red-orange",
            "blanket": "cornflower-blue",
            "blankets": "cornflower-blue",
            "serviceconfirmation": "koromiko",
            "timesheet": "koromiko",
            "categoryworkbench": "koromiko",
            "chargesheet": "cornflower-blue",
            "forecastmodeling": "red-orange",
            "RequestTemplate": "red-orange",
            "RequestForm": "red-orange",
            "incidentreport" : "red-orange",
            "Segmentation": "red-orange",
            "FactSheet": "red-orange",
            "SupplierRequest": "red-orange"
        };

        var docStateTextColors = {
            'draft': 'pending-status-text',
            'waitlisted': 'pending-status-text',
            'invited': 'pending-status-text',
            'partialreceipt': 'pending-status-text',
            'approved': 'success-status-text',
            'approvalpending': 'pending-status-text',
            'pending': 'pending-status-text',
            'approvalrequired': 'pending-status-text',
            'identified': 'success-status-text',
            'senttopartner': 'success-status-text',
            'registered': 'success-status-text',
            'executed': 'success-status-text',
            'disqualified': 'error-status-text',
            'amendmentinprogress': 'pending-status-text',
            'ordered': 'pending-status-text',
            'default': 'notAvailable-status-text'
        }

        var cardsBucketIdentifierConstants = {
            "drafts": "getDraftsData",
            "pendingapprovals": "getPendingApprovalData",
            "followup": "getFollowUpData",
            "pendingacceptance": "getPendingAcceptanceData",
            "pendingreceivings": "getPendingReceivingsData"
        };

        var formWidgetItemClasses = {
            //  P2P
            "P2P_CMN_BillTo": "icon_BillTo",
            "P2P_CMN_DeliverTo": "icon_DeliverTo",
            "P2P_REQ_ERPOrderType": "icon_OrderERP",
            "P2P_Req_OnBehalfOf": "icon_OnBehalf",
            "P2P_Req_Requester": "",
            "P2P_Currency": "",
            "P2P_REQ_Department": "",
            "P2P_Req_Urgent": "",
            "P2P_Req_Name": "",
            "P2P_Req_Number": "",
            "P2P_CMN_ShipTo": "",
            "P2P_REQ_WorkOrder": "icon_Order"
        };

        var subAppCodes = {
            Portal: 101,
            PartnerNetwork: 102,
            Sourcing: 103,
            Contract: 104,
            Partner: 105,
            Reports: 106,
            P2P: 107,
            Catalog: 108,
            Repository: 109,
            WorkBench: 110,
            Scorecard: 520
        };

        var preferenceLOBType = {
            All: -1,
            None: 0,
            Belong: 1,
            Serve: 2
        };

        var userPreferences = {};
        var orderSource = {
            "None": 0,
            "ManualOrder": 1,
            "RequisitionOrder": 2,
            "ConfirmingOrder": 3,
            "CatalogOrder": 4,
            "ChangeOrder": 5,
            "ChangeRequest": 6,
            "FlipToOrder": 7,
            "BlanketOrder": 8,
            "ReleaseOrder": 9,
            "InternalChangeOrder": 10
        }

        var enumWQBuckets = {
            "1": "Drafts",
            "2": "PendingApprovals",
            "3": "ActionPending",
            "4": "FollowUp",
            "5": "UnprocessedRequisitions"
        }

        var AdHocApprovalsStatus = {
            "APPROVED": "APPROVED",
            "PENDING": "PENDING",
            "NOT_SENT_FOR_APPROVAL": "NOT SENT FOR APPROVAL",
            "NOT_SENT_FOR_REVIEW": "NOT SENT FOR REVIEW",
            "ACCEPTED": "ACCEPTED",
            "APPROVAL": "APPROVAL",
            "REJECTED": "REJECTED",
            "POOLAPPROVED": "POOL APPROVED",
            "WITHDRAWN": "WITHDRAWN",
            "APPROVEDOFFLINE": "OFFLINE",
            "ISSKIPPED": "IS SKIPPED",
            "REVIEWPENDING": "REVIEW PENDING",
            "SKIPPED_DUE_TO_ESCALATION": "SKIPPED DUE TO ESCALATION",
            "CANCELLED": "CANCELLED"
        }

        var ReviewerTypeEnums = {
            "GroupReviewer" : 12,
            "AutoReviewer" : 13,
            "AdhocReviewer" : 14
        }

        var ReviewTypeEnums = {
            "ReviewGroup" : 13,
            "AdhocReviewGroup" : 14
        }

        var AdHocApprovalsStatusEnums = {
            "Rejected": 0,
            "Approved": 1,
            "ApprovalPending": 2,
            "PoolApproved": 3,
            "AutoApproved": 4,
            "Withdrawn": 5,
            "ApprovedOffline": 6,
            "BudgetOverridePending": 7,
            "BudgetOverriden": 8,
            "IsSkipped": 13,
            "ACCEPTED": 12,
            "REVIEWPENDING": 11,
            "NOT_SENT_FOR_APPROVAL": 99, 
            "NOT_SENT_FOR_REVIEW": -1,
            "CANCELLED": 15
        }
        var WFSkipTypeEnums = {
            "None": 0,
            "RequesterDefined": 1,
            "ApproverDefined": 2,
            "SystemSkip": 3,
            "UrgentSkip": 4
        }
        var ProxyApproverTypeEnums = {
            "None": 0,
            "Delegated": 1,
            "Alternate": 2,
            "Escalated": 3,
            "Reassigner": 4,            
            "EscalatedReassigned":5,
            "EscalatedDelegated":6,
	    "LeadEscalatedReassigned":7,
            "LeadEscalatedDelegated":8,
            "ReAssignedDelegated":9
        }
        var ApprovalWorkFlowEnums = {
            "PersonBasedHR": 1,
            "CategoryApproval": 2,
            "PoolApproval": 3,
            "AutoApproval": 4,
            "CategoryHR": 5,
            "RequesterDefinedParallel": 6,
            "RequesterDefinedPool": 7,
            "RequesterDefinedHR": 8,
            "ApprovalGroup": 9,
            "UserDefinedApproval": 11,
            "SpecificUser": 12
        }
        var ApprovalWorkFlowName = {
            "PersonBasedHR": "HR Approval",
            "CategoryApproval": "Category Approval",
            "PoolApproval": "Poll Approval",
            "AutoApproval": "Automatic Approval",
            "ApprovalGroup": "Group Approval",
            "UserDefinedApproval": "User Defined Approval",
            "CostCenterApproval": "Cost Center Approval",
            "SpecificUser": "Users",
            "RequesterDefinedHR": "Requester Defined HR" 
        }
        var appHomeUrl = "";
        var appContextUrl = "";
        var purchaseTypesWithMappings = [];
        var defaultHeaderEntityValues = [];
        var IsADRSourceExist = false;
        var IsShipFromLocationVisible = false;
        var ShipFromLocationType = 0;
        var docCorrectStatus = {
            1: {
                106: ["EvaluationInProgress"]
            },
            2: {
                106: ["EvaluationInProgress"]
            },
            3: {
                106: ["EvaluationInProgress"]
            },
            5: {
                35: ["COMMON_SendForSignature"],
                36: ["COMMON_SignedBySignatory"],
                37: ["COMMON_RejectedBySignatory"],
                38: ["COMMON_SendForSupplierSignature"],
                41: ["COMMON_SubmittedToPartner"],
                42: ["COMMON_PendingWithBuyer"],
                83: ["COMMON_Executed"],
                126: ["COMMON_Terminate"],
                196: ["COMMON_TermCollaborationPending"],
                199: ["COMMON_DraftModification"],
                200: ["COMMON_Modified"],
                229: ["COMMON_LineReviewPending"],
                230: ["COMMON_LinesReviewed"],
                195: ["COMMON_LinesCollaborationPending"],
                257: ["COMMON_SignatureProcessInitiated"],
                258: ["COMMON_SignaturePending"],
                259: ["COMMON_SignatureRejected"],
                260: ["COMMON_Signed"]
            },
            9: {
                121: ["Returned"]
            },
            11: {
                44: ["Finalized"]
            },
            12: {
                44: ["Finalized"]
            },
            21: {
                44: [""]
            },
            23: {
                44: ["Finalized"]
            }
        };
        var requestDocId = [16, 17, 18, 27];
        var docTypeStatus = {
            41: {
                dType: [9, 10, 7, 8],
                name: "SentToPartner"
            },
            42: {
                dType: [1, 2, 3, 4],
                name: "ResponseSubmitted"
            },
            44: {
                dType: [12, 11],
                name: "Finalized"
            },
            102: {
                dType: [10, 7, 8],
                name: "SubmittedToBuyer"
            },
            121: {
                dType: [9],
                name: "Returned"
            },
            46: {
                dType: [12],
                name: "Finalized",
                defName: "New"
            },
            47: {
                IsSupplier: true,
                name: "Accepted"
            },
            48: {
                dType: [1, 2, 3, 4],
                name: "Declined",
                IsSupplier: true,
                defStatus: {
                    5: "ContractSupplierRejected"
                }
            },
            4: {
                IsSupplier: false,
                name: "Draft"
            },
            166: {
                IsSupplier: true,
                name: "Closed"
            },
            176: {
                dType: [9, 10, 7, 8],
                IsSupplier: true,
                name: "SubmittedToBuyer"
            },
            21: {
                dType: [31,65],
                name: "ApprovalPending"
            },
            0: {
                dType: [8],
                name: "NotReceived"
            },
            1: {
                dType: [65],
                name: "Draft"
            },
            22: {
                dType: [65],
                name: "ApprovedandNotInvited"
            },
            23: {
                dType: [65],
                name: "Rejected"
            },
            24: {
                dType: [65],
                name: "Withdrawn"
            }
        }
        var flipDocs = [1, 2, 3, 5];
        var searchType = {
            savedSearch: 1,
            RecentSearch: 2,
            TemplateAdminSaveFilter :3,
            TemplateSaveFilter : 4,
            ContractLanguageTemplateSaveFilter :5
        }
        var constantURLAndQueryStringValue = angular.extend(((typeof (userInfo) !== 'undefined' && userInfo.constantURLAndQueryStringValue) ? userInfo.constantURLAndQueryStringValue : {}), {
            "actionPlanQueryString": "md=bT0yJnNtPTQx0",
            "assessmentQueryString": "md=bT0yJnNtPTc1",
            "auctionQueryString": "md=bT0yJnNtPTU1",
            "auctionRequestQueryString": "md=bT0zMSZzbT0zNA2",
            "blanketQueryString": "md=bT0xMyZzbT01MA2",
            "catalogQueryString": "md=bT0xMyZzbT0xNA2",
            "contractQueryString": "md=bT0yJnNtPTY1",
            "contractRequestQueryString": "md=bT0zMSZzbT0zMg2",
            "creditMemoQueryString": "md=bT0xMyZzbT0zNw2",
            "documentTypeCodes": "101",
            "formQueryString": "md=bT0yJnNtPTI40",
            "homeQueryString": "md=bT0x0",
            "invoiceQueryString": "md=bT0xMyZzbT0xOA2",
            "invoiceReconcillationQueryString": "md=bT0xMyZzbT0zMA2",
            "moduleScope": "All",
            "orderQueryString": "md=bT0xMyZzbT0xNg2",
            "partnerdocumentTypeCodes": "105",
            "partnersQueryString": "md=bT0xOQ2",
            "paymentRequestQueryString": "md=bT0zMSZzbT00Nw2",
            "programQueryString": "md=bT0xMyZzbT00NA2",
            "projectQueryString": "md=bT0zNQ2",
            "receiptQueryString": "md=bT0xMyZzbT0xNw2",
            "returnNoteQueryString": "md=bT0xMyZzbT0yNw2",
            "requisitionQueryString": "md=bT0xMyZzbT0xNQ2",
            "rfxQueryString": "md=bT0yJnNtPTQ1",
            "rfxRequestQueryString": "md=bT0zMSZzbT0zMw2",
            "serviceConfirmationQueryString": "md=bT0xMyZzbT01MQ2",
            "workBenchQueryString": "md=bT0yJnNtPTg1",
            "portalURL": typeof (userInfo) != 'undefined' ? userInfo.URLs.AppURL : ""//For 1.0 manage approval page (Model)
        });

        var oloc = {
            "invoiceOloc": 225,
            "rfxOloc": 219,
            "orderOloc": 226,
            "reqOloc": 227,
            "irOloc": 225,
            "formOloc": 105,
            "scorcardOloc": 520,
            "partnerOloc": 105,
            "contractOloc": 104,
            "projectOloc": 223,
            "procurementProfileOloc": 232,
            "Persistence": 229,
            "categoryworkbenchOloc":116,
            "forecastmodeling": 316,
            "RequestFormOloc":557,
            "CreateIncidentOloc": 539,
            "CreateSegmentationOloc": 539,
            "FactSheet": 638,
            "SupplierRequest": 105
        }

        var docExceptionType = {
            5: 'Quantity Exception',
            9: 'UnitPrice Exception',
            12: 'Line Item Value Exception',
            15: 'Item Total Exception',
            18: 'Tax Exception',
            21: 'Shipping Exception',
            24: 'Charges Exception',
            27: 'Total Amount Exception',
            29: 'UOM Exception',
            38: 'Non PO Exception',
            39: 'Item Mismatch Exception',
            42: 'Approval Required Exception',
            43: 'Expired Invoice Exception',
            44: 'Invalid PO Exception',
            45: 'Invalid Requester Exception',
            46: 'Invalid Currency Exception',
            52: 'Advances Exception',
            55: 'Recoupment Exception',
            56: 'Missing Receipt Exception'

        }

        var invoiceSource = {
            "1": "PO Based Invoice",
            "2": "NON PO Based Invoice"
        }

        var ERS = {
            "0": "No",
            "1": "Yes"
        }

        var IsAdvance = {
            0: "P2P_Common_No",
            1: "P2P_Common_Yes"
        }

        var InterfaceDocumentStatusForContract = {
            1: "PICK_CONTRACT",
            2: "POST_CONTRACT",
            3: "UpdatedPick_CONTRACT",
            4: "UpdatedPost_CONTRACT",
            5: "NewFailure_CONTRACT",
            6: "UpdatedFailure_CONTRACT",
            99: "NewPickedupforProcessing_CONTRACT",
            100: "UpdatedPickedupforProcessing_CONTRACT",
            101: "SendingToERPInProgress_CONTRACT",
            102: "SendingToERPFailed_CONTRACT",
            103: "UpdatedSendingToERPInProgress_CONTRACT",
            104: "UpdatedSendingToERPFailed_CONTRACT"
        };
        var ExtendedStatus = {
            0:"None",
            1:"PendingValidation",
            2:"ValidationFailed"            
        };

        return {
            "doctypeConstants": doctypeConstants,
            "lobEntityDetailCode": lobEntityDetailCode,
            "docStateConstants": docStateConstants,
            "docStateConstants_supplier": docStateConstants_supplier,
            "smartNavTileConfig": smartNavTileConfig,
            "documentPriority": documentPriority,
            "setDocumentPriority": setDocumentPriority,
            "cardsBucketIdentifierConstants": cardsBucketIdentifierConstants,
            "docType": docType,
            "doctypeImages": doctypeImages,
            "docStateImages": docStateImages,
            "doctypeColors": doctypeColors,
            "docStateColors": docStateColors,
            "formWidgetItemClasses": formWidgetItemClasses,
            "globalSearchConstant": globalSearchConstant,
            "userPreferences": userPreferences,
            "subAppCodes": subAppCodes,
            "preferenceLOBType": preferenceLOBType,
            "userActivityStatus": userActivityStatus,
            "orderSource": orderSource,
            "purchaseTypesWithMappings": purchaseTypesWithMappings,
            "fvrtNav": fvrtNav,
            "docStateTextColors": docStateTextColors,
            "enumWQBuckets": enumWQBuckets,
            "olvmObj": olvmObj,
            "AdHocApprovalsStatus": AdHocApprovalsStatus,
            "WFSkipTypeEnums": WFSkipTypeEnums,
            "ProxyApproverTypeEnums": ProxyApproverTypeEnums,
            "AdHocApprovalsStatusEnums": AdHocApprovalsStatusEnums,
            "ReviewerTypeEnums": ReviewerTypeEnums,
            "ReviewTypeEnums": ReviewTypeEnums,
            "ApprovalWorkFlowEnums": ApprovalWorkFlowEnums,
            "ApprovalWorkFlowName": ApprovalWorkFlowName,
            "appHomeUrl": appHomeUrl,
            "appContextUrl": appContextUrl,
            "defaultHeaderEntityValues": defaultHeaderEntityValues,
            "IsADRSourceExist":IsADRSourceExist,
            "docTypeStatus": docTypeStatus,
            "OnEvent": OnEvent,
            "isNewGrid": isNewGrid,
            "MatchType": MatchType,
            "MatchtypeEnable": MatchtypeEnable,
            "docCorrectStatus": docCorrectStatus,
            "requestDocId": requestDocId,
            "flipDocs": flipDocs,
            "searchType": searchType,
            "constantURLAndQueryStringValue": constantURLAndQueryStringValue,
            "contractList": contractList,
            "contractNumberValidationCheckOnSubmit": contractNumberValidationCheckOnSubmit,
            "contractNumberType": contractNumberType,
            "InterfaceStatus": InterfaceStatus,
            "oloc": oloc,
            "dispatchMode": dispatchMode,
            "reportIconConstants": reportIconConstants,
            "opportunityFinderIcons": opportunityFinderIcons,
            "matchTypeConstants": matchTypeConstants,
            "reqToOrder": reqToOrder,
            "ModifyOrder": ModifyOrder,
            "source": source,
            "common": common,
            "auctionTypeConstants": auctionTypeConstants,
            "docExceptionType": docExceptionType,
            "invoiceSource": invoiceSource,
            "requisitionSource": requisitionSource,
            "InvoicingStatus": InvoicingStatus,
            "OrderInvoicingStatus": OrderInvoicingStatus,
            "MaskedBuyerInvoiceCreatorName" : "AP User",
            "ERS": ERS,
            "InvoiceCreationStatus": InvoiceCreationStatus,
            "IsApprover":IsApprover,
            "isBlanket" : isBlanket,
            "DocumentExtendedStatus": DocumentExtendedStatus,
            "InterfaceDocumentStatusForContract": InterfaceDocumentStatusForContract,
            "InvoiceComplianceStatus": InvoiceComplianceStatus,
            "InvoiceArchivalStatus": InvoiceArchivalStatus,
            "IsAdvance": IsAdvance,
            "ExtendedStatus": ExtendedStatus
        };
    };
})(angular);
